<template>
  <div>
    <div class="top"
      :style="'background:url(../static/images/cs/' + imgs[id] + ');background-position-x: center; background-position-y: center;background-repeat: no-repeat;'">
    </div>
    <div class="products">
      <product-item v-for="(item, i) in list" :key="i" :src="item.ImageThumbnail" :title="item.Name" />

    </div>
  </div>
</template>
<script>
import producItem from './base/product-item'
import axios from 'axios'

export default {
  name: 'product',
  components: {
    'product-item': producItem
  },
  data () {
    return {
      id: 0,
      imgs: ['fj2.jpg', 'hy.jpg', '4690fa890b89b4abffb4d772eb497f38.jpg'],
      list: []
    }
  },
  created () {
    var that = this
    this.id = this.$route.params.id
    axios({ url: 'http://wms.xingyunyi.cn/api/PublicChannel/All', method: 'get', params: {} }).then(response => {
      that.list = []
      for (var i = 0; i < response.data.Data.length; i++) {
        var item = response.data.Data[i]
        if (item.ChannelType === that.id && item.IsShow) {
          that.list.push(item)
        }
      }
    })
  }
}
</script>
<style scoped>
.top {
  width: 100%;
  background-image: url('../images/top2.jpg');
  height: 199px;
  margin-bottom: 50px;
}

.products {
  width: 1300px;
  min-height: 800px;
  height: auto;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/products.vue